import { useContext } from 'react'
import { LoaderContext, type LoaderProviderType } from '../Context/LoaderProvider'

export const useLoader = (): LoaderProviderType => {
  const context = useContext(LoaderContext)
  if (!context) {
    throw new Error('useLoader must be used within a LoaderProvider')
  }
  return context
}